import { Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from "@angular/router";
import { ModalController, NavController } from "@ionic/angular";
import { BobToastService } from "src/app/shared/toast";
import { TranslateService } from "@ngx-translate/core";
import { filter, Subscription } from "rxjs";
import { AppService } from "src/app/_services/app.service";
import { LocalStorageService } from "src/app/_services/localStorage.service";
import { ProviderService } from "src/app/_services/provider.service";
import { PusherService } from "src/app/_services/pusher.service";
import { KeyboardService } from "src/app/_services/keyboard.service";

@Component({
  selector: "app-prestataire-footer",
  templateUrl: "./prestataire-footer.component.html",
  styleUrls: ["./prestataire-footer.component.scss"],
  standalone: false,
})
export class PrestataireFooterComponent implements OnInit, OnDestroy {
  confirmDemandModal: any[] = [];
  meeetingStatus: string = "PENDING";
  modalText = "";
  validText = "";
  accepted = false;
  refused = false;
  bankLinkModal = false;
  backgroundLocationAlwaysModal = false;
  showCancleModal = false;
  cancleText = "";
  currentDemandId: any;
  currentDevisID: any;
  devis_id: any = null;
  private routerSubscription!: Subscription;
  private keyboardSubscription!: Subscription;
  activatedRouteIndex = 0;
  isKeyboardVisible: boolean = false;
  private lastDemandCancelHandledAt = 0;
  private demandCancelNavigationScheduled = false;
  private readonly demandCancelDedupMs = 3000;

  constructor(
    private router: Router,
    private providerService: ProviderService,
    private localStorageServices: LocalStorageService,
    private laravelEchoService: PusherService,
    private navController: NavController,
    private modalController: ModalController,
    private route: ActivatedRoute,
    private bobToast: BobToastService,
    private appService: AppService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private keyboardService: KeyboardService,
    private ngZone: NgZone
  ) {
    this.subscribeToMeeting();
    router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.closeModals();
      }
    });
  }

  ngOnInit() {
    // this.subscribeUserUpdated();
    this.subscruibeDemandCancle();
    this.subscribeToProblemReporting();
    this.subscribeAdminCancelDemande();
    this.subscribeBankLinkModal();
    this.subscribeBackgroundLocationAlwaysModal();
    this.subscribeRoutes();
    this.subscribeToKeyboard();
    this.handleRouteChange(this.router.url);
  }
  subscribeRoutes() {
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        this.handleRouteChange(event.urlAfterRedirects);
      });
  }
  handleRouteChange(url: string) {
    const demandesRoutes = [
      "/prestataire/demandes",
      "/prestataire/track-demands",
      "/prestataire/devis/",
      "/prestataire/devis-resume",
      "/prestataire/demande-images/",
    ];
    const profileRoutes = [
      "/prestataire/menu",
      "/prestataire/profile",
      "/prestataire/notifications",
      "/prestataire/configurations",
      "/prestataire/contact",
      "/prestataire/monnaie",
    ];

    if (url === "/prestataire") {
      this.activatedRouteIndex = 0;
    } else if (demandesRoutes.some((route) => url.startsWith(route))) {
      this.activatedRouteIndex = 1;
    } else if (profileRoutes.some((route) => url.startsWith(route))) {
      this.activatedRouteIndex = 2;
    } else {
      this.activatedRouteIndex = 0;
    }
  }

  subscribeCancelModal() {
    this.appService.cancelModalObservable().subscribe((val: any) => {
      this.showCancleModal = val.open;
    });
  }
  subscribeBankLinkModal() {
    this.appService.bankLinkModalObservable().subscribe((val: any) => {
      this.bankLinkModal = val;
    });
  }

  subscribeBackgroundLocationAlwaysModal() {
    this.appService.backgroundLocationAlwaysModalObservable().subscribe((val: boolean) => {
      this.backgroundLocationAlwaysModal = val;
    });
  }

  subscribeToKeyboard() {
    this.keyboardSubscription = this.keyboardService.getKeyboardState().subscribe(
      (isVisible: boolean) => {
        this.isKeyboardVisible = isVisible;
      }
    );
  }

  // subscribeUserUpdated() {
  //   this.laravelEchoService
  //     .dispatcherUserUpdatedObservable()
  //     .subscribe((data: any) => {
  //       if (data != null && data != undefined) {
  //         let user = data.data;
  //         let token = this.localStorageServices.getToken();
  //         this.localStorageServices.saveAuthData(token || "", user);
  //       }
  //     });
  // }
  subscribeAdminCancelDemande() {
    this.laravelEchoService
      .dispatcherAdminCancelDemandeObservable()
      .subscribe((data: any) => {
        if (data != null && data != undefined) {
          this.providerService.storeDemandData(null);
          this.localStorageServices.dropCurrentDemand();
          const currentRoute = this.router.url.split("?")[0];
          if (currentRoute !== "/prestataire" && currentRoute !== "/prestataire/") {
            this.scheduleNavigateToPrestataireHome();
          }
        }
      });
  }

  dispatchUpdateUser(userdata: any) {
    let payload = {
      type_event: "UPDATE_USER",
      data: userdata,
    };
    this.laravelEchoService.computeEvents(payload);
  }
  subscruibeDemandCancle() {
    this.laravelEchoService
      .OnraodDemandeCanceledObservable()
      .subscribe((data: any) => {
        if (data != null) {
          void this.handleProviderDemandCanceled();
        } else {
          this.closeModals();
        }
      });
    this.laravelEchoService
      .dispatcherDemandeStatusUpdatedObservable()
      .subscribe((res: any) => {
        if (res?.demande_status === "CANCELED") {
          void this.handleProviderDemandCanceled();
        }
      });
  }

  private async handleProviderDemandCanceled(): Promise<void> {
    const now = Date.now();
    if (now - this.lastDemandCancelHandledAt < this.demandCancelDedupMs) {
      return;
    }
    this.lastDemandCancelHandledAt = now;

    this.localStorageServices.dropCurrentDemand();
    this.providerService.storeDemandData(null);
    this.closeModals();

    await this.bobToast.warningBottom(
      this.translate.instant("PROVIDER.DAMANDE.CANCELED_MESSAGE"),
      { duration: 4000 }
    );
    this.scheduleNavigateToPrestataireHome();
  }

  private scheduleNavigateToPrestataireHome(delayMs = 100): void {
    if (this.demandCancelNavigationScheduled) {
      return;
    }
    this.demandCancelNavigationScheduled = true;
    setTimeout(() => {
      this.demandCancelNavigationScheduled = false;
      this.ngZone.run(() => {
        const currentRoute = this.router.url.split("?")[0];
        if (currentRoute === "/prestataire" || currentRoute === "/prestataire/") {
          return;
        }
        void this.router.navigate(["/prestataire/"]);
      });
    }, delayMs);
  }

  subscribeToProblemReporting() {
    this.laravelEchoService
      .dispatcherSignlerProblemProviderObservable()
      .subscribe((res: any) => {
        this.localStorageServices.dropCurrentDemand();
        this.providerService.storeDemandData(null);

        void this.showFooterToast(
          this.translate.instant("DEVIS_PAGE.DEMANDE_SIGNALED_CLIENT")
        );
      });
  }
  subscribeToMeeting() {
    this.laravelEchoService
      .AcceptMeetingResponseObservable()
      .subscribe((data: any) => {
        this.meeetingStatus = data.data.status;
        if (data.data.status == "ACCEPTED") {
          void this.showFooterToast(
            this.translate.instant("RDV_PAGE.SUCCESS_MODAL_MESSAGE_ACCEPTED")
          );
          this.localStorageServices.dropCurrentDemand();
        } else {
          this.confirmDemandModal = [data.data];
        }
      });
  }
  private async showFooterToast(text: string): Promise<void> {
    await this.bobToast.warningBottom(text, { duration: 4000 });
    this.closeModals();
    this.scheduleNavigateToPrestataireHome();
  }
  closeCancleModal() {
    this.closeModals();
    this.scheduleNavigateToPrestataireHome();
  }
  prestataireDemands() {
    this.providerService.prestataireDemands();
  }
  closeModals() {
    this.laravelEchoService.resetStatusChanged();
    // this.canceled_demand = false;
    this.confirmDemandModal.length = 0;
    void this.modalController.dismiss(undefined, "navigation").catch(() => undefined);
  }
  closeModal() {
    this.closeModals();
  }
  goTo(destination: string) {
    this.router.navigate([`prestataire/${destination}`]);
  }
  validModal() {
    if (this.accepted) {
      this.closeModals();
      this.modalController.dismiss();
      this.accepted = false;
      this.navController.navigateForward([
        "/prestataire/demande-images/" + this.currentDevisID,
      ]);
    } else if (this.refused) {
      this.refused = false;
      this.closeModals();
      this.modalController.dismiss();
      this.navController.navigateForward([
        "/prestataire/devis/" + this.currentDemandId,
      ]);
    } else {
      this.navController.navigateForward(["/prestataire/"]);
    }
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
    this.keyboardSubscription?.unsubscribe();
  }
}
